import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

import Breadcrumb from "./Breadcrumb";
import Time from "./../Common/Time";

const SecondaryNavbar = ({ onItemClick, scrollStack }) => {
  return (
    <header role="banner" className={classNames("secondary-navbar")}>
      <Breadcrumb onItemClick={onItemClick} scrollStack={scrollStack} />
      <Time />
    </header>
  );
};

SecondaryNavbar.propTypes = {
  onItemClick: PropTypes.func.isRequired,
  scrollStack: PropTypes.array.isRequired
};

export default SecondaryNavbar;



// WEBPACK FOOTER //
// ./src/components/Layout/SecondaryNavbar.js